module.exports = __webpack_public_path__ + "static/media/logotipo-pd-blanco.bd436131.png";